import {useEffect, useState} from "react";
import {Col, Row} from "antd";
import _ from "lodash";
import ActionBar from "~/layout/ActionBar";
import {Icon, Loading} from "~/components";
import {
	apiError,
	handleRequest,
	numberFormat
} from "~/utils";
import {reportApi, saleApi} from "~/api";
import {useGroup} from "~/hooks";
import {
	SaleCallSourceSearch,
	SaleCallSourceTable
} from "../../components";
import {Bar, Doughnut} from "react-chartjs-2";
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	ArcElement,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, ArcElement, BarElement, Title, Tooltip, Legend);

const cards = [
	{key: 'sources', label: 'Nguồn tìm được', color: '#16a34a'},
	{key: 'calls', label: 'Cuộc gọi trong kỳ', color: '#2563eb'},
	{key: 'called', label: 'Nguồn đã gọi', color: '#0891b2'},
	{key: 'uncalled', label: 'Nguồn chưa gọi', color: '#dc2626'},
	{key: 'appointment', label: 'Nguồn đã hẹn', color: '#16a34a'},
];

function SaleCallSourceReport() {

	const listGroup = useGroup();

	const [userOptions, setUserOptions] = useState([]);
	const [loading, setLoading] = useState(true);
	const [filter, setFilter] = useState({groupId: undefined, userId: undefined});
	const [data, setData] = useState({
		total: {sources: 0, called: 0, uncalled: 0, appointment: 0, calls: 0},
		groups: [],
		chart: {labels: [], sources: [], calls: [], appointment: []},
	});

	//Danh sách nhân viên trong phạm vi quyền (để lọc)
	useEffect(() => {
		(async () => {
			const [error, response] = await handleRequest(saleApi.callSourceTransferUsers());
			if(!error && response?.data) {
				setUserOptions(response.data.map((user) => ({
					value: user.id,
					label: `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.username,
				})));
			}
		})();
	}, []);

	//Load báo cáo
	useEffect(() => { handleLoad().then(); }, [filter]);

	const handleLoad = async () => {
		setLoading(true);
		const [error, response] = await handleRequest(reportApi.saleCallSource(filter));
		const message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);
		if(!message) {
			setData(response.data);
		}
		setLoading(false);
	}

	const handleFilterChange = (key, value) => {
		setFilter((prev) => ({...prev, [key]: value, page: 1}));
	};

	const barData = {
		labels: data.chart.labels,
		datasets: [
			{label: 'Nguồn tìm được', backgroundColor: 'rgb(54, 162, 235)', data: data.chart.sources},
			{label: 'Cuộc gọi', backgroundColor: 'rgb(255, 159, 64)', data: data.chart.calls},
			{label: 'Đã hẹn', backgroundColor: 'rgb(75, 192, 120)', data: data.chart.appointment},
		],
	};

	const barOptions = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {y: {grid: {display: false}, beginAtZero: true}, x: {grid: {display: false}}},
		plugins: {
			legend: {position: 'top'},
			title: {display: true, text: 'Nguồn tìm được & cuộc gọi theo nhân viên'},
		},
	};

	const doughnutData = {
		labels: ['Chưa gọi', 'Đã gọi (chưa hẹn)', 'Đã hẹn'],
		datasets: [{
			data: [
				data.total.uncalled,
				Math.max(data.total.called - data.total.appointment, 0),
				data.total.appointment,
			],
			backgroundColor: ['rgb(255, 99, 132)', 'rgb(54, 162, 235)', 'rgb(75, 192, 120)'],
		}],
	};

	return (
		<>
			<ActionBar title={'Báo cáo gọi điện tìm nguồn'}></ActionBar>
			<div className="container d-block">
				<SaleCallSourceSearch filter={filter} listGroup={listGroup} userOptions={userOptions} onChange={handleFilterChange} />
				<div className="content-scroll" style={{padding: '12px'}}>
					<div className="content-shadow pd-1 w-100 mb-3">
						<Row gutter={10}>
							{cards.map((card) => (
								<Col xs={12} sm={8} md={Math.floor(24 / cards.length)} key={card.key}>
									<div className="mb-1" style={{padding: '10px 12px', borderRadius: '8px', background: '#f7f8fa', border: '1px solid #eef0f3'}}>
										<div style={{fontSize: '13px', color: '#6b7280', marginBottom: '4px'}}>{card.label}</div>
										<div style={{fontSize: '20px', fontWeight: 700, lineHeight: 1.2, color: card.color}}>{numberFormat(data.total[card.key])}</div>
									</div>
								</Col>
							))}
						</Row>
					</div>

					<div className="content-shadow pd-1 w-100 mb-3">
						<Row gutter={10}>
							<Col xs={24} md={16}>
								<div style={{height: '360px'}}>
									{!loading && <Bar options={barOptions} data={barData} />}
								</div>
							</Col>
							<Col xs={24} md={8}>
								<div style={{height: '360px'}} className="d-flex align-items justify-content-center">
									{!loading && <Doughnut options={{responsive: true, maintainAspectRatio: false, plugins: {legend: {position: 'bottom'}, title: {display: true, text: 'Tỉ lệ trạng thái nguồn'}}}} data={doughnutData} />}
								</div>
							</Col>
						</Row>
					</div>

					<div className="content-shadow pd-1 w-100">
						{loading && <Loading />}
						{(!loading && !_.isEmpty(data.groups)) && <SaleCallSourceTable groups={data.groups} />}
						{(!loading && _.isEmpty(data.groups)) && (
							<div className="text-center pd-2 color-gray">
								<div style={{fontSize: '32px'}}>{Icon.search}</div>
								<p>Không có dữ liệu nguồn gọi điện trong khoảng thời gian này</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	)
}

export default SaleCallSourceReport;
